var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Notification Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MAPS:-NA-Wires",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Banner-/-Building-Blocks-/-Top-Banner",
    transform: "translate(-33.000000, -17.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification-Icon",
    transform: "translate(32.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,12 C23,18.0741541 18.0753834,23 12.000792,23 C5.9246166,23 1,18.0741541 1,12 C1,5.92584593 5.9246166,1 12.000792,1 C18.0753834,1 23,5.92584593 23,12 L23,12 Z M12.000792,8.07199424 C12.6518108,8.07199424 13.1792786,7.54298056 13.1792786,6.89200864 C13.1792786,6.24103672 12.6518108,5.71360691 12.000792,5.71360691 C11.3497732,5.71360691 10.8223054,6.24103672 10.8223054,6.89200864 C10.8223054,7.54298056 11.3497732,8.07199424 12.000792,8.07199424 L12.000792,8.07199424 Z M12.7864497,15.9280058 L14.3577651,15.9280058 L14.3577651,17.4992081 L9.64381885,17.4992081 L9.64381885,15.9280058 L11.2151343,15.9280058 L11.2151343,11.2143988 L9.64381885,11.2143988 L9.64381885,9.64319654 L12.7864497,9.64319654 L12.7864497,15.9280058 Z",
    id: "Info"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconFilled);
export default __webpack_public_path__ + "static/media/info-icon-filled.967fe06096557e3c6a9ee0f778bf70a4.svg";
export { ForwardRef as ReactComponent };